import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a98f9cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "modernization-description",
  "data-aos": "fade-up"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_BannerComponent = _resolveComponent("BannerComponent")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_CardComponent = _resolveComponent("CardComponent")!
  const _component_SectionComponent = _resolveComponent("SectionComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderComponent, { screenName: "" }),
    _createVNode(_component_BannerComponent, {
      imageSrc: "capabilities/business intelligence/title-page-business-intelligence.jpg",
      bannerHeadingColor: '#fff',
      isOverlay: true,
      heading: "Business Intelligence",
      subheading: "Illuminate the Path to Success"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { xs: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_ctx.appModernizationDesc), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_CardComponent, {
      subHeading: `BENEFITS`,
      cardItems: _ctx.benefitsItems
    }, null, 8, ["cardItems"]),
    _createVNode(_component_CardComponent, {
      subHeading: `CORE CAPABILITIES`,
      cardItems: _ctx.coreCapabilitiesItems
    }, null, 8, ["cardItems"]),
    _createVNode(_component_SectionComponent, {
      relatedTitle: "RELATED CAPABILITIES AND SOLUTIONS",
      paragraphContent: _ctx.paragraphContent,
      sections: _ctx.sectionContents,
      cards: _ctx.cardData,
      "additional-content": _ctx.additionalContent
    }, null, 8, ["paragraphContent", "sections", "cards", "additional-content"]),
    _createVNode(_component_FooterComponent)
  ]))
}